const rtlLanguages = ["ar","dv","fa","he","prs","ps","syr","ug","ur"]

/** @param {Intl.DateTimeFormatOptions} options */
export function getDateFnsFormatString(locale, options) {
    const formatter = createFormatter(locale, options);
    const parts = formatter.formatToParts(FORMAT_TEST_DATE);
    const localeOptions = formatter.resolvedOptions();
    
    return parts.map(({ type, value }) => (DATE_PART_TOKEN_FORMATTERS[type] || DATE_PART_TOKEN_FORMATTERS.literal)(value, localeOptions)).join('');
  }
  
  function createFormatter(locale, options) {
    return new Intl.DateTimeFormat(locale, options || {});
  }
  
  // A date with single digit values in all parts to helps disabmiguate between 12 and 24 hour formats, and variable length strings
  const FORMAT_TEST_DATE = new Date('2007-06-05T04:03:02.001');
  
  // [DA]: MUI's pickers only properly generate masks for basic fixed length formats with numbers and literals
  // that break if there are multiple literals between the numbers.
  // But a maskless input will properly parse input values in any specified format that works with the adapter.
  // Since we work with date-fns, we do our best to map the format of the current locale to the dateFns format string.
  // Most date and time parts are coerced to the fixed length 2 digit or 4 digit formats to support masked inputs.
  const DATE_PART_TOKEN_FORMATTERS = {
    day(value) { return 'dd'; },
    dayPeriod(value) { return 'aa'; }, // [DA]: The MUI picker always extends the pattern to a full uppercase AM/PM
    era(value) { return 'GG'; }, // [DA]: This doesn't work well in the MUI picker. Text will appear but BC cannot be typed
    fractionalSecond(value) { return 'S'; }, // [DA]: The MUI picker only properly types the first value of the fractional second part
    hour(value, { hourCycle, hour12 }) { // [DA]: hourCycle and hour12 will be present in all formats that display an hour
      // [DA]: MUI lack support for h11 and h23 formats. If ever supported this should change to the following:
      // const cycleIdentifier = { h11: 'K', h12: 'h', h23: 'k', h24: 'H' }[hourCycle] || (hour12 ? 'h' : 'H');
      const cycleIdentifier = { h11: 'h', h12: 'h', h23: 'H', h24: 'H' }[hourCycle] || (hour12 ? 'h' : 'H');
      return cycleIdentifier.repeat(2);
    },
    literal(value) { return value.replace('\u200e', '').replace('\u200f', ''); },
    minute(value) { return 'mm'; },
    month(value) {
      if (/^\d+$/.test(value))
        return 'MM';
  
      switch (value.length) {
        case 1: return 'MMMMM';
        case 3: return 'MMM';
        default: return 'MMMM';
      }
    },
    relatedYear(value) { return 'y'.repeat(Math.max(value.length, 4)); },
    second(value) { return 'ss'; },
    timeZoneName(value) { return 'OOOO'; }, // [DA]: Too lazy to properly implement at the moment. It's not likely to be used in a date picker
    weekday(value) {
      if (/^\d+$/.test(value))
        return 'ii';
  
      switch (value.length) {
        case 1: return 'iiiii';
        case 2: return 'iiiiii';
        case 3: return 'iii';
        default: return 'iiii';
      }
    },
    year(value) { return 'y'.repeat(Math.min(value.length, 4)); },
    yearName(value) { return ''; }, // [DA]: Not supported by date-fns
  };
  
  export { rtlLanguages }